/* tslint:disable */
import { Injectable } from '@angular/core';
import { User } from '../../models/User';
import { Role } from '../../models/Role';
import { Paciente } from '../../models/Paciente';
import { Medicion } from '../../models/Medicion';
import { Empresa } from '../../models/Empresa';
import { Contenedor } from '../../models/Contenedor';
import { Usuario } from '../../models/Usuario';
import { MedicionEstado } from '../../models/MedicionEstado';
import { Sucursal } from '../../models/Sucursal';
import { UsuarioSucursal } from '../../models/UsuarioSucursal';
import { UsuarioRol } from '../../models/UsuarioRol';
import { Rol } from '../../models/Rol';
import { Estado } from '../../models/Estado';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    User: User,
    Role: Role,
    Paciente: Paciente,
    Medicion: Medicion,
    Empresa: Empresa,
    Contenedor: Contenedor,
    Usuario: Usuario,
    MedicionEstado: MedicionEstado,
    Sucursal: Sucursal,
    UsuarioSucursal: UsuarioSucursal,
    UsuarioRol: UsuarioRol,
    Rol: Rol,
    Estado: Estado,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/services/custom/SDKModels.ts